import { Component } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-additional-text-pdp',
  templateUrl: './custom-additional-text-pdp.component.html',
  styleUrls: ['./custom-additional-text-pdp.component.scss'],
  standalone: false
})
export class CustomAdditionalTextPdpComponent {
  product$: Observable<Product> = this.currentProductService.getProduct();

  constructor(
    protected currentProductService: CurrentProductService
  ) { }
}
